<template>
  <div>
    <el-button :disabled="isCountingDown" @click="startC" size="small">
      {{ isCountingDown ? `${countDown}s` : '发送验证码' }}
    </el-button>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const emit = defineEmits(['sendVerifyCode'])

const countDown = ref(60);
const isCountingDown = ref(false);

const startC = () => {
  emit('sendVerifyCode')

}

const startCountdown = () => {

  if (isCountingDown.value) return;

  isCountingDown.value = true;

  const intervalId = setInterval(() => {
    countDown.value -= 1;
    if (countDown.value <= 0) {
      clearInterval(intervalId);
      isCountingDown.value = false;
      countDown.value = 60; // 重置倒计时
    }
  }, 1000);

  // 这里可以添加发送验证码的API调用逻辑
};

defineExpose({
  startCountdown
})
</script>

<style scoped>

</style>